import { Api } from '../api';
import { user } from '../endpoints';
import type { GetStatusResponse } from './models';

export class UserApi extends Api {
  static getStatus = (signal?: AbortSignal) => this.get<GetStatusResponse>(user.status(), { signal });
}
